<template>
  <el-dialog :visible.sync="dialogVisible" title="Save Filter" width="30%">
    <div
      class="text-center"
    >Please provide a meaningful title by which this filter will be identified.</div>
    <el-form label-width="120px" :model="form" :rules="rules" ref="saveForm">
      <el-form-item label="Title" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleSave">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SurveyFilterSaveDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    form: {
      title: '',
    },
    rules: {
      title: [
        {
          required: true,
          trigger: 'blur',
          message: 'Please enter a title for this survey filter.',
        },
      ],
    },
  }),
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visiblity) {
        this.$emit('onVisibleChanged', visiblity);
      },
    },
  },
  methods: {
    resetAndHideDialog() {
      this.$refs.saveForm.resetFields();
      this.$emit('onVisibleChanged', false);
    },
    handleCancel() {
      this.resetAndHideDialog();
    },
    handleSave() {
      this.$refs.saveForm.validate(valid => {
        if (!valid) {
          return false;
        }

        this.$emit('onSave', this.form.title);
        this.resetAndHideDialog();
        return true;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// SurveyFilterSaveDialog.vue?47253220